import { useCallback, useEffect, useState } from 'react'
import {
	getReminderCooldownRemainingMs,
	isReminderOnCooldown,
	recordReminderSent,
} from '../utils/assignmentReminderCooldown'

export const useAssignmentReminderCooldown = (assignmentId, refreshKey = 0) => {
	const [tick, setTick] = useState(0)

	const onCooldown = isReminderOnCooldown(assignmentId)

	useEffect(() => {
		if (!onCooldown || !assignmentId) return undefined
		const remaining = getReminderCooldownRemainingMs(assignmentId)
		if (remaining <= 0) {
			setTick(value => value + 1)
			return undefined
		}
		const timer = window.setTimeout(() => setTick(value => value + 1), remaining + 50)
		return () => window.clearTimeout(timer)
	}, [assignmentId, onCooldown, tick, refreshKey])

	const markReminderSent = useCallback(() => {
		recordReminderSent(assignmentId)
		setTick(value => value + 1)
	}, [assignmentId])

	return { onCooldown, markReminderSent }
}
